/**
 * 2007-2017 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Open Software License (OSL 3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * http://opensource.org/licenses/osl-3.0.php
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2017 PrestaShop SA
 * @license   http://opensource.org/licenses/osl-3.0.php Open Software License (OSL 3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import $ from 'jquery';
import prestashop from 'prestashop';
import 'velocity-animate';
$(document).ready(() => {
  prestashop.on('clickQuickView', function(elm) {
    let data = {
      'action': 'quickview',
      'id_product': elm.dataset.idProduct,
      'id_product_attribute': elm.dataset.idProductAttribute,
    };
    $.post(prestashop.urls.pages.product, data, null, 'json').then(function(resp) {
      $('body').append(resp.quickview_html);
      let productModal = $(`#quickview-modal-${resp.product.id}-${resp.product.id_product_attribute}`);
      productModal.modal('show');
      productConfig(productModal);
      productModal.on('hidden.bs.modal', function() {
        productModal.remove();
      });
    }).fail((resp) => {
      prestashop.emit('handleError', {eventType: 'clickQuickView', resp: resp});
    });
  });
  var productConfig = (qv) => {
    let thumbnails = qv.find('.js-qv-product-images');
    $('.js-thumb').on('click', (event) => {
      if ($('.js-thumb').hasClass('selected')) {
        $('.js-thumb').removeClass('selected');
      }
      $(event.currentTarget).addClass('selected');
      $('.js-qv-product-cover').attr('src', $(event.target).data('image-large-src'));
    });
    setTimeout(() => {
      thumbnails.slick({
        slidesToShow: 4,
        infinite: false,
        slidesToScroll: 1,
        dots: false,
        vertical: true,
        draggable: false,
        prevArrow: '<i class="fl-outicons-chevron1 arrow-up js-arrow-up"></i>',
        nextArrow: '<i class="fl-outicons-chevron2 arrow-down js-arrow-down"></i>'
      });
    }, 300);
    qv.find('#quantity_wanted').TouchSpin({
      verticalbuttons: true,
      verticalupclass: 'touchspin-up',
      verticaldownclass: 'touchspin-down',
      buttondown_class: 'btn btn-touchspin js-touchspin',
      buttonup_class: 'btn btn-touchspin js-touchspin',
      min: 1,
      max: 1000000
    });
  };
  $('body').on('click', '#search_filter_toggler', function() {
    $('#search_filters_wrapper').addClass('active');
  });
  $('#search_filter_controls .clear').on('click', function() {
    $('#search_filters_wrapper').removeClass('active');
  });
  $('#search_filter_controls .ok').on('click', function() {
    $('#search_filters_wrapper').removeClass('active');
  });
  const parseSearchUrl = function(event) {
    if (event.target.dataset.searchUrl !== undefined) {
      return event.target.dataset.searchUrl;
    }
    if ($(event.target).parent()[0].dataset.searchUrl === undefined) {
      throw new Error('Can not parse search URL');
    }
    return $(event.target).parent()[0].dataset.searchUrl;
  };
  $('body').on('change', '#search_filters input[data-search-url]', function(event) {
    prestashop.emit('updateFacets', parseSearchUrl(event));
  });
  $('body').on('click', '.js-search-filters-clear-all', function(event) {
    prestashop.emit('updateFacets', parseSearchUrl(event));
  });
  $('body').on('click', '.js-search-link', function(event) {
    event.preventDefault();
    prestashop.emit('updateFacets', $(event.target).closest('a').get(0).href);
  });
  $('body').on('change', '#search_filters select', function(event) {
    const form = $(event.target).closest('form');
    prestashop.emit('updateFacets', '?' + form.serialize());
  });
  prestashop.on('updateProductList', (data) => {
    updateProductListDOM(data);
  });
});
function updateProductListDOM(data) {
  $('#search_filters').replaceWith(data.rendered_facets);
  $('#js-active-search-filters').replaceWith(data.rendered_active_filters);
  $('#js-product-list-top').replaceWith(data.rendered_products_top);
  $('#js-product-list').replaceWith(data.rendered_products);
  $('#js-product-list-bottom').replaceWith(data.rendered_products_bottom);
}



// WEBPACK FOOTER //
// ./js/listing.js